// have table numbers not indexes
var hints = [
    //risiko1
    {
        student: [1],
        default: [1],
    },
    //risiko2
    {
        student: [1,4,14],
        retired: [1,3,14],
        default: [1,2,14],
    },
    //risiko3
    {
        student: [1,7,15],
        retired: [1,6,15],
        default: [1,5,15],
    },
    //risiko4
    {
        student: [1,10,16],
        retired: [1,9,16],
        default: [1,8,16],
    },
    //risiko5
    {
        student: [1,13,17],
        retired: [1,12,17],
        default: [1,11,17],
    },
];


export default hints;